import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { useTranslation } from 'react-i18next'
import FormTextField from './FormTextField'

const FormDatePicker = ({ formProps, inputConfig, itemProps }) => {
  const { t } = useTranslation()

  const { label, disabled } = itemProps || {}
  const { field: { ref, onChange, ...fieldProps } = {} } = formProps || {}
  const { ...otherItemProps } = itemProps || {}

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        disabled={disabled}
        label={label}
        onChange={value => {
          onChange(value?.toDate())
        }}
        mindate={itemProps?.dateprops?.mindate}
        maxdate={itemProps?.dateprops?.maxdate}
        inputRef={ref}
        {...fieldProps}
        inputFormat="yyyy-MM-DD"
        renderInput={params => {
          const { InputProps, inputProps, inputRef } = params
          return (
            <FormTextField
              InputProps={InputProps}
              inputRef={inputRef}
              inputProps={{
                ...inputProps,
                placeholder: t('format.date'),
              }}
              itemProps={otherItemProps}
              formProps={formProps}
              inputConfig={{ sx: { width: 200 }, ...inputConfig }}
            />
          )
        }}
      />
    </LocalizationProvider>
  )
}

export default FormDatePicker
